"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var propTypes = {
  onResetFilters: _propTypes.default.func.isRequired
};

var TimelineClearFiltersButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineClearFiltersButton, _PureComponent);

  function TimelineClearFiltersButton() {
    (0, _classCallCheck2.default)(this, TimelineClearFiltersButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineClearFiltersButton).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelineClearFiltersButton, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIButton.default, {
        "data-selenium-test": "timeline-clear-filters-button",
        use: "transparent",
        onClick: this.props.onResetFilters
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "profileContentTimeline.filters.clearFilters"
      }));
    }
  }]);
  return TimelineClearFiltersButton;
}(_PureComponent2.default);

TimelineClearFiltersButton.propTypes = propTypes;
var _default = TimelineClearFiltersButton;
exports.default = _default;
module.exports = exports.default;